import PropTypes from 'prop-types'
import {Flex, Box} from '@chakra-ui/react'

import RedemptionPartners from '../RedemptionPartners'

const PartnersTab = ({currentSupplier}) => {
  return (
    <Flex flex="auto" direction="column" gap="sm">
      <Box flexGrow={1}>
        <Flex direction="column" gap="sm">
          <RedemptionPartners currentSupplier={currentSupplier} />
        </Flex>
      </Box>
    </Flex>
  )
}

PartnersTab.propTypes = {
  currentSupplier: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default PartnersTab
